<template>
  <button
    v-if="back"
    @click="backFn"
    class="btn"
    :class="{'btn--left': direction === 'left', 'btn--full-width': fullWidth, 'btn--has-border': hasBorder, 'btn--right': direction === 'right', 'btn--inverse': inverse}"
  >{{text}}</button>

  <router-link
    v-else
    class="btn btn--link"
    :class="{'btn--left': direction === 'left', 'btn--full-width': fullWidth, 'btn--has-border': hasBorder, 'btn--right': direction === 'right', 'btn--inverse': inverse}"
    :to="to"
  >{{text}}</router-link>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    direction: String,
    to: {
      type: String
    },
    inverse: Boolean,
    hasBorder: Boolean,
    back: Boolean,
    fullWidth: Boolean
  },
  methods: {
    backFn() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../scss/variables";
.btn {
  border: 4px solid black;
  background-color: white;
  text-transform: uppercase;
  color: currentColor;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.25rem;
  box-sizing: border-box;
  height: 48px;
  position: relative;
  font-family: $font;
  font-size: 0.85em;
  &:hover {
    cursor: pointer;
  }

  &--full-width {
    width: 100%;
    &.btn--left,
    &.btn--right {
      width: calc(100% - 25px);
    }
  }

  &--link {
    text-decoration: none;
  }

  &--inverse {
    background-color: black;
    color: white;
    &::after {
      background-color: black !important;
    }
  }

  &--left {
    border-top: 4px solid #fff;
    border-bottom: 4px solid #fff;
    border-right: 4px solid #fff;
    border-left: none;
    border-radius: 5px 0 0 5px;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 28px;
      height: 28px;
      top: 2px;
      left: -17px;
      border: 4px solid #fff;
      background-color: white;
      border-radius: 5px 0 5px 0;
      transform: rotate(45deg);
      z-index: -1;
    }
    &.btn--inverse {
      background-color: black;
      color: white;
      &::after {
        background-color: black !important;
      }
      &.btn--has-border {
        border-color: #fff;
        &:after {
          border-color: #fff;
        }
      }
    }
    &.btn--has-border {
      border-color: #000;
      &::after {
        border-color: #000;
      }
    }
  }
  &--right {
    border-top: 4px solid #fff;
    border-bottom: 4px solid #fff;
    border-left: 4px solid #fff;
    border-right: none;
    border-radius: 0 5px 5px 0;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 28px;
      height: 28px;
      top: 2px;
      right: -17px;
      border: 4px solid #fff;
      background-color: white;
      border-radius: 5px 0 5px 0;
      transform: rotate(45deg);
      z-index: -1;
    }
    &.btn--inverse {
      background-color: black;
      border-color: #000;
      color: white;
      &::after {
        background-color: black;
        border-color: #000;
      }
      &.btn--has-border {
        border-color: #fff;
        &:after {
          border-color: #fff;
        }
      }
    }
    &.btn--has-border {
      border-color: #000;
      &::after {
        border-color: #000;
      }
    }
  }
}
</style>
